import APIClient from "../api";

export default class DashboardService extends APIClient {

    constructor(props: any) {
        super(props);
    }

    async getReportList(userId: number) {
        const url = `${this.endpoint}/DashboardList/${userId}`;

        return this.api({
            method: 'get',
            url
        });
    }

    async getReportInfo(id: number, idUser: number) {
        const url =  `${this.endpoint}/Dashboard/${id}?idUser=${idUser}`;

        return this.api({
            method: 'get',
            url
        });
    }

}